import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';

const InvestmentsPage = () => {
  const investmentHighlights = [
    {
      title: "Diversification",
      description: "Portfolio spans real estate, private equity, and private credit strategies"
    },
    {
      title: "Track Record",
      description: "20% IRR / 2X EM projected returns on average across investments"
    },
    {
      title: "Cash Flow",
      description: "80% of capital contribution expected to be recouped through management fees"
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', mb: 6 }}>
        Our Investments
      </Typography>
      
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Portfolio Overview
        </Typography>
        <Grid container spacing={4} sx={{ mb: 4 }}>
          {investmentHighlights.map((item, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Card sx={{ height: '100%', boxShadow: 3 }}>
                  <CardContent sx={{ p: 4 }}>
                    <Typography variant="h5" component="h3" gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Featured Investment: Revelstoke Capital
        </Typography>
        <Grid container spacing={6} alignItems="center" sx={{ mb: 4 }}>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Box
                component="img"
                src="/revelstoke-office.jpg"
                alt="Revelstoke Capital"
                sx={{ width: '100%', borderRadius: 2, boxShadow: 3 }}
              />
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                Healthcare Services Specialist
              </Typography>
              <Typography variant="body1" paragraph>
                Revelstoke Capital is a Denver-based middle-market private equity firm specializing in healthcare services with $2.8 billion in fee-paying AUM.
              </Typography>
              <Typography variant="body1" paragraph>
                The firm has achieved a 3.1X gross MOIC across realized investments and has experienced over 100% fund-over-fund growth in its last two flagship funds.
              </Typography>
              <Typography variant="body1" paragraph>
                Revelstoke's exclusive focus on healthcare services provides investors with exposure to a $4 trillion market through a disciplined investment approach.
              </Typography>
            </motion.div>
          </Grid>
        </Grid>

        <Box sx={{ backgroundColor: '#f5f5f5', p: 4, borderRadius: 2, mb: 4 }}>
          <Typography variant="h5" component="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
            Investment Highlights
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ul>
                <li>Proven track record with 3.1x MOIC on realized investments</li>
                <li>Top decile returns compared to peers</li>
                <li>Demonstrated ability to scale AUM (100% fund growth)</li>
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <ul>
                <li>Experts in healthcare services niche</li>
                <li>Disciplined investors selecting top 5% of opportunities</li>
                <li>High-margin business model</li>
              </ul>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box>
        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
          Other Portfolio Companies
        </Typography>
        <Typography variant="body1" paragraph>
          Aquamire's portfolio includes minority stakes in over 20 private market managers across real estate, private equity, and private credit strategies. Each investment undergoes rigorous due diligence to ensure alignment with our investment criteria and portfolio construction objectives.
        </Typography>
      </Box>
    </Container>
  );
};

export default InvestmentsPage;
